import ConvalidaOtpRichiestaCredenziali from "../../components/RichiesteAccesso/RichiestaCredenzialiAccesso/RichiesteAccessoComponent/ConvalidaOtpRichiestaCredenziali";


export default function ConvalidaRichiestaCredenziali() {

    return (
        <ConvalidaOtpRichiestaCredenziali />
    )
}